import App from '../src/App'
import 'babel-polyfill'
import colors from 'vuetify/lib/util/colors'
import router from './router'
import store from './store'
import time from './time'
import VueProgressBar from '@aacassandra/vue3-progressbar'
import vuetify from './plugins/vuetify'
import { createApp } from 'vue'

const app = createApp(App)

app.config.globalProperties.$filters = {
  pesoFormat(value) {
    return `₱ ${parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
  },
  upperCaseFirstCharacter(value) {
    return value.charAt(0).toUpperCase()
  }
}

app.use(VueProgressBar, {
  color: colors.blue.base,
  failedColor: colors.red.base
}).use(router)
  .use(store)
  .use(time)
  .use(vuetify)
  .mount("#app")
